// @flow
import _ from 'lodash';

import window from 'window';

import ko from 'rgs-knockout';
import type { Observable, Disposable } from 'rgs-knockout';
import type { ComponentInfo } from 'rgs-knockout/types';
import keycode from 'keycode';
import type { TDropdownWithTypeaheadOptions } from 'rgs-nfd-ui-kit/ko-components/dropdown';
import { Dropdown } from 'rgs-nfd-ui-kit/ko-components/dropdown';

// rgs-nfd-ui-kit/typeahead
import { withTypeahead } from '../dropdown/components/typeahead/typeahead';
import { default as TypeaheadTemplate } from './template/container.html';

function useDefault (mapper) {
	return (item: any, inputValue: string) => {
		const mappedValue = (mapper(item) || '').toUpperCase();

		return mappedValue.includes(inputValue.toUpperCase());
	};
}

export type TypeaheadProps = TDropdownWithTypeaheadOptions & {
	primary: {
		tempInputValue: Observable
	}
}

//same logic, but different template
export class Typeahead extends withTypeahead(Dropdown) {
	tempInputValue: Observable = ko.observable();
	props: TypeaheadProps;

	_disposableTempInputValue: Disposable;

	constructor (options: { props: DropdownOptions }, ref: ComponentInfo) {
		super(options, ref);

		this._disposableTempInputValue = this._listenTempInputValue();

		this.onInit();
	}

	onInit (): void {
		window.addEventListener('keydown', this.handleKeyDown);
	}

	_listenTempInputValue (): Disposable {
		const subscription = this.primary
			.tempInputValue
			.subscribe(this.handlers.onInputChange);

		return subscription;
	}

	handleInputChange = (callback: (string) => void, inputValue: any) => {
		const isOpened = this.props.isOpened;//if inherited

		if (callback) {
			callback(inputValue);
		}

		if (isOpened && !isOpened.peek()) {
			isOpened(true);
		}
		this.primary.tempInputValue(inputValue);
	};

	_submitInput (): void {
		this.primary.inputValue(this.primary.tempInputValue());
	}

	handleKeyDown = (e: Event): boolean => {
		if (e.which === keycode('escape') || e.which === keycode('enter')) {
			this._submitInput();
			this.closeDropdown();
		}

		return true; // must be!
	};

	assignHandlers (handlers: any) {
		const {
			onItemClick,
			onInputChange,
			onTypeaheadToggle,
			onFilterBy,
			onMapItemValue,
		} = handlers || {};

		return {
			onItemClick: this.handleClickByItem.bind(null, onItemClick),
			onInputChange: (value: string) => this.handleInputChange(onInputChange, value),
			onMapItemValue: onMapItemValue,
			onTypeaheadToggle: onTypeaheadToggle || _.noop,
			onFilterBy: onFilterBy || useDefault(onMapItemValue), //will be filter items on ui
		};
	}

	dispose (): void {
		window.removeEventListener('keydown', this.handleKeyDown);

		if (super.dispose) {
			super.dispose();
		}

		if (this._disposableTempInputValue) {
			this._disposableTempInputValue.dispose();
		}
	}
}

export const COMPONENTS_TYPEAHEAD_NAME = 'typeahead';

export const COMPONENTS_TYPEAHEAD_ENTITIES = [
	{
		name: COMPONENTS_TYPEAHEAD_NAME,
		entity: Typeahead,
		template: TypeaheadTemplate,
	},
];
